import React from 'react';
import './ViewContextModal.css';
import { Context } from '../services/contextService';

interface ViewContextModalProps {
  isOpen: boolean;
  onClose: () => void;
  context: Context;
}

const ViewContextModal: React.FC<ViewContextModalProps> = ({ isOpen, onClose, context }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{context.name}</h2>
        <div className="form-group">
          <label htmlFor="contextTextView">Context Content</label>
          <textarea
            id="contextTextView"
            value={context.text || 'No content available.'}
            readOnly
            rows={15}
          />
        </div>
        <div className="modal-actions">
          <button type="button" className="button-primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ViewContextModal; 